import {
  CMS_API_BASE,
  type InitiatePairingResponse,
  type CompletePairingResponse,
  type WsUrlResponse,
} from './types';

/**
 * Initiate pairing by calling POST /api/pairing/initiate.
 * Generates a deviceId if none provided.
 */
export async function initiatePairing(
  deviceId: string,
): Promise<InitiatePairingResponse> {
  const res = await fetch(`${CMS_API_BASE}/api/pairing/initiate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ deviceId }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(body.message || `Pairing initiate failed (${res.status})`);
  }

  return res.json();
}

/**
 * Poll pairing status by calling POST /api/pairing/complete.
 * Returns pending or confirmed status.
 */
export async function pollPairingComplete(
  deviceCode: string,
): Promise<CompletePairingResponse> {
  const res = await fetch(`${CMS_API_BASE}/api/pairing/complete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ deviceCode }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(body.message || `Pairing complete failed (${res.status})`);
  }

  return res.json();
}

/**
 * Request a SigV4-signed WSS URL for MQTT over WebSocket connection.
 * Called with the device JWT to authenticate.
 */
export async function fetchWsUrl(jwt: string): Promise<WsUrlResponse> {
  const res = await fetch(`${CMS_API_BASE}/api/player/ws-url`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(body.message || `WS URL fetch failed (${res.status})`);
  }

  return res.json();
}
